import { createSurveyStyles } from '@sm/webassets';

const useStyles = createSurveyStyles(theme => ({
  text: {
    color: theme.questionColor,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
  },
}));

export default useStyles;
